import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const CompanyContext = createContext(null);

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CompanyProvider = ({ children }) => {
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCompanies = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/api/companies`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        setCompanies(data.companies || []);
        
        // Load saved company from localStorage or use first company
        const savedCompanyId = localStorage.getItem('selectedCompanyId');
        const savedCompany = data.companies?.find(c => c.id === savedCompanyId);
        
        if (savedCompany) {
          setSelectedCompany(savedCompany);
        } else if (data.companies?.length > 0) {
          setSelectedCompany(data.companies[0]);
          localStorage.setItem('selectedCompanyId', data.companies[0].id);
        }
      }
    } catch (error) {
      console.error('Failed to fetch companies:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  const selectCompany = (company) => {
    setSelectedCompany(company);
    localStorage.setItem('selectedCompanyId', company.id);
  };

  return (
    <CompanyContext.Provider value={{ 
      companies, 
      selectedCompany, 
      selectCompany, 
      loading,
      companyId: selectedCompany?.id 
    }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};
